<div *ngIf="loaded && notifications.length > 0">
  <div class="action-bar">
    <div class="spacer"></div>
    
    <div class="right-section">
      <mat-form-field appearance="fill" class="search-field transparent-background">
        <input (keyup)="applyFilter($event)" matInput placeholder="{{ 'ACTIONS.FILTER' | translate }}" #input />
      </mat-form-field>

      <button mat-button id="refresh-btn" (click)="$event.stopPropagation(); refreshNotifications()">
        <mat-icon [@rotatedState]="state">cached</mat-icon>
      </button>
    </div>
  </div>

  <h2 style="margin-left: 2rem">{{ "NOTIFICATIONS.NOTIFICATIONS" | translate }}</h2>

  <mat-chip-listbox selectable style=" margin: 1rem;" class="flex center">
    <mat-chip-option [matBadge]="notificationsCountRead" [selected]="typeOfFilter === 'read'"
      (click)="$event.stopPropagation(); filterRead(true)">
      {{ "NOTIFICATIONS.READ" | translate }}
    </mat-chip-option>
    <mat-chip-option [matBadge]="notificationsCountNotRead" [selected]="typeOfFilter === 'unread'"
      (click)="$event.stopPropagation(); filterRead(false)">
      {{ "NOTIFICATIONS.UNREAD" | translate }}
    </mat-chip-option>
    <mat-chip-option [matBadge]="notificationsCount" [selected]="typeOfFilter === 'all'"
      (click)="$event.stopPropagation(); filterRead(null)">
      {{ "NOTIFICATIONS.ALL" | translate }}
    </mat-chip-option>
  </mat-chip-listbox>

  <div class="action-buttons">
    <button mat-stroked-button color="accent" (click)="setAllRead()">
      {{"NOTIFICATIONS.SET_ALL_AS_READ" | translate}}
    </button>
    <button mat-raised-button color="warn" (click)="deleteAllNotifications()">
      {{"ACTIONS.DELETE_ALL" | translate}}
    </button>
  </div>

  <cdk-virtual-scroll-viewport itemSize="120" class="notification-viewport">
    <div *cdkVirtualFor="let n of notificationsFiltered">
      <div class="separator"></div>
      <app-notification-row [notification]="n"></app-notification-row>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="loaded && notifications.length < 1" class="center">
  <h3> {{"NOTIFICATIONS.NO_NOTIFICATIONS" | translate}}</h3>
</div>
